// extracted by mini-css-extract-plugin
export default {"retryAlert":"LocalPaymentsRetryInitiator-module__retryAlert--EQPTm","retryMainAlert":"LocalPaymentsRetryInitiator-module__retryMainAlert--qzPxc"};